require("./main.scss");

import * as React from "react";

interface OwnProps {
}

const Main: React.FunctionComponent<OwnProps> = ({ children }) => {
    React.useEffect(() => {
    }, []);

    return (
        <>
            <>{children}</>
        </>
    );
};

export default Main;